// Tri d'un contenu de dossier : les dossiers toujours en premier, puis le
// critère demandé. `localeCompare` pour les noms, afin que les accents se
// classent correctement.
//
// Trie EN PLACE, comme le faisait App.js : le tableau trié est le `child` du
// noeud de l'arbre mutable, et le rendu est déclenché ensuite.
export function sortElements(elements, sortType, sortOrder){
    return elements.sort((a, b) => {
        if(a.type === 'folder' && b.type === 'file'){ return -1; }
        if(b.type === 'folder' && a.type === 'file'){ return 1; }
        if(sortType === 'name'){
            return sortOrder === 'asc'
                ? a.name.localeCompare(b.name)
                : b.name.localeCompare(a.name);
        }
        if(sortType === 'size'){
            return sortOrder === 'asc' ? a.size - b.size : b.size - a.size;
        }
        return 0;
    });
}
